import React, { Component } from 'react';
import classnames from 'classnames';
import Lightbox from 'react-images';
import './gallery.css';
import env from '../../../config/env';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
      indexPhoto: null,
      lightboxIsOpen: true,
      currentImage: 0,
    };

    this.onClickPhoto = this.onClickPhoto.bind(this);
    this.onClosePhoto = this.onClosePhoto.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
  }

  componentWillMount() {
    this.setState({
      currentImage: 0,
    });
  }

  onClickPhoto(indx) {
    this.setState({
      showDetails: true,
      indexPhoto: indx,
      lightboxIsOpen: true,
    })
  }

  onClosePhoto() {
    this.setState({
      showDetails: false,
      indexPhoto: null,
    })
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  gotoImage(index) {
    this.setState({
      currentImage: index,
    });
  }

  closeLightbox() {
    this.setState({
      showDetails: false,
      lightboxIsOpen: false,
      currentImage: 0,
    })
  }

  renderPortfolio() {
    const { portfolio } = this.props;
    const { showDetails, indexPhoto } = this.state;
    return portfolio.map((image, indx) => {
      return (
        <figure key={image._id} className={classnames({ 'active': showDetails && indexPhoto === indx })} onClick={() => this.onClickPhoto(indx)} style={{ backgroundImage: `url(${env.url}${image.fotos[0].path})` }}>
          <div className="gallery-title">{image.title}</div>
        </figure>
      );
    });
  }

  renderPortfolioText() {
    const { portfolio } = this.props;
    const { indexPhoto } = this.state;
    let fotosData = [];

    portfolio[indexPhoto].fotos.map((photo) => {
      fotosData.push(
        {
          "src": `${env.url}${photo.path}`,
        }
      );
    });

    return (
      <Lightbox
        currentImage={this.state.currentImage}
        images={fotosData}
        isOpen={this.state.lightboxIsOpen}
        onClickPrev={this.gotoPrevious}
        onClickNext={this.gotoNext}
        onClose={this.closeLightbox}
        onClickThumbnail={this.gotoImage}
        showThumbnails={true}
      />
    );
  }

  render() {
    const { showDetails, indexPhoto } = this.state;
    const { portfolio } = this.props;

    return (
      <section className="grid3d vertical" id="grid3d">
        <div className={classnames('grid-wrap', { 'view-full': showDetails })}>
          <div className="grid">
            {this.renderPortfolio()}
          </div>
        </div>
        {indexPhoto !== null &&
          <div className={classnames('contentText', { 'show': showDetails })}>
            <div className={classnames({ 'show': showDetails })}>
              <div className="dummy-img">
                <h1>{portfolio[indexPhoto].title}</h1>
                {this.renderPortfolioText()}
              </div>
            </div>
            <span className="loading"></span>
            <span className="icon close-content" onClick={this.onClosePhoto}></span>
          </div>
        }
      </section>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/portfolio/gallery/Gallery.js